"use client";

import { useEffect, useState } from "react";
import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const DeleteModal = ({
  isOpen,
  onClose,
  onDelete,
  resourceName,
  className,
}: {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  resourceName: string;
  className?: string;
}) => {
  const [width, setWidth] = useState("320px");

  useEffect(() => {
    if (window.innerWidth > 480) {
      setWidth("480px");
    }
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className={cn("text-center", className)} innerClassName={`p-8`}>
        <h5 className={"mb-4 text-lg font-bold"}>Usuń {resourceName}</h5>
        <p className={"black mb-4"}>
          Czy na pewno chcesz usunąć {resourceName}?
        </p>
        <div className={"flex items-center justify-center gap-4"}>
          <Button variant={"outline"} className={"w-full"} onClick={onDelete}>
            Tak
          </Button>
          <Button variant={"blue"} className={"w-full"} onClick={onClose}>
            Nie
          </Button>
        </div>
        <DialogClose />
      </DialogContent>
    </Dialog>
  );
};
